import axios from "axios";
const DD_WEBHOOK_BASE_URL = `${window['getConfig'].DD_APP_URL}`;
const getordercountbystoreid=(body)=>{
   return axios.post(`${DD_WEBHOOK_BASE_URL}/webjob/crmgetordercountbystoreid`,body,{
        headers: {
            'Authorization': `7acd9210777446838188a20fc9f4a0318a7cc023e58783e8925d42133148c6f6`,
        }});
};

export{
    getordercountbystoreid
}